<template>
<td v-bind="$attrs" @mouseleave="onCellFocusOut"
    colspan="1" 
    role="gridcell">
  <div class="flex items-center">
    <button class="my-button flex items-center" aria-label="Detalle" @click="onClickAction" ref="button">
      {{ buttonName }}
      <base-icon size="xs" name="fullscreen" :ariaHidden="true" />
    </button>
    <!-- <base-button mode='primary' aria-label="Detalle" @click='onClickAction' ref="button" :text="buttonName"/> -->
  </div>
</td>

</template>
<script>
import { i18n } from '@/i18n'

export default {
  inheritAttrs: false,
  components: {
  },
  data () {
    return {
      show: false,
      mouseOverPopup: false,
      buttonName: i18n.t('app.button_detail')
    }
  },
  mounted: function () {
    this.show = false
  },
  props: {
    dataItem: Object
  },
  methods: {
    onClick (e) {
      this.show = true
    },
    onClickAction (e) {
      this.$emit('actionselect', { dataItem: this.dataItem, action: e.target.id })
      this.show = !this.show
    },
    onFocusOut (e) {
      this.show = false
      this.mouseOverPopup = false
    },
    onCellFocusOut (e) {
      setTimeout(() => {
        if (!this.mouseOverPopup) {
          this.show = false
        }
        this.mouseOverPopup = false
      })
    },
    onMouseEnter () {
      this.mouseOverPopup = true
    }
  }
}
</script>

<style scoped>
    .my-button {
        border-radius: 18px;
        background-color: transparent;
        color: var(--primary-800);
        /* text-decoration: u nderline; */
    }
    .dark .my-button{
      color: var(--primary-600);
    }

    .action {
        margin: 10px 20px 10px 20px;
        cursor: pointer
    }
</style>
